import * as i0 from "@angular/core";
import * as i1 from "primeng/components/common/messageservice";
export class MessageToastService {
    // eslint-disable-next-line
    constructor(messageService) {
        this.messageService = messageService;
    }
    showToastError(title, msg, key) {
        this.messageService.add({
            key,
            severity: 'error',
            summary: title,
            detail: msg,
        });
    }
    showToastSuccess(title, msg, key) {
        this.messageService.add({
            key,
            severity: 'success',
            summary: title,
            detail: msg,
        });
    }
    showToastWarn(title, msg, key) {
        this.messageService.add({
            key,
            severity: 'warn',
            summary: title,
            detail: msg,
        });
    }
    clear(key) {
        this.messageService.clear(key);
    }
}
MessageToastService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MessageToastService_Factory() { return new MessageToastService(i0.ɵɵinject(i1.MessageService)); }, token: MessageToastService, providedIn: "root" });
